import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';

/**
 * ŞİFREMİ UNUTTUM — telefonla sorulur, e-postaya gönderilir.
 *
 * Giriş telefonla yapıldığı için kullanıcıya da telefonunu soruyoruz: sahadaki
 * kişi numarasını bilir, kayıtlı adresini bilmeyebilir.
 *
 * ⚠️ SONUÇ EKRANI KASITLI OLARAK BELİRSİZ. "Numara kayıtlı değil" ya da
 *    "bu hesabın e-postası yok" demiyoruz — o mesajlar, sisteme kimin kayıtlı
 *    olduğunu dışarıdan öğrenmeye yarardı. Bunun yerine ne yapılacağı yazıyor.
 */
export function SifremiUnuttum({ onGeri }: { onGeri: () => void }) {
  const [telefon, setTelefon] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [bitti, setBitti] = useState(false);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setGonderiliyor(true);
    // Sunucu her koşulda ok döner; hata da olsa aynı ekranı gösteriyoruz.
    await api.post('/auth/sifremi-unuttum', { telefon }).catch(() => undefined);
    setBitti(true);
    setGonderiliyor(false);
  }

  return (
    <main className="flex min-h-dvh items-center justify-center bg-surface-2 p-4">
      <div className="w-full max-w-sm rounded-(--radius-mod) border border-line bg-surface p-6 shadow-(--shadow-mod)">
        <h1 className="text-xl font-semibold text-navy">Şifremi unuttum</h1>

        {bitti ? (
          <>
            <p className="mt-4 rounded-(--radius-mod) border border-ok-line bg-ok-bg p-4 text-sm leading-relaxed text-ink">
              Hesabınızda kayıtlı bir e-posta adresi varsa, şifre belirleme
              bağlantısı oraya gönderildi. Bağlantı <strong>1 saat</strong> geçerlidir.
            </p>
            <p className="mt-3 text-xs leading-relaxed text-wait">
              Mail gelmediyse: hesabınızda e-posta kayıtlı olmayabilir. Bu durumda
              şantiye şefiniz ya da sistem yöneticiniz şifrenizi elle belirleyebilir.
            </p>
            <button
              onClick={onGeri}
              className="mt-5 w-full rounded-(--radius-mod) bg-navy px-4 py-2.5 font-medium text-white"
            >
              Giriş ekranına dön
            </button>
          </>
        ) : (
          <form onSubmit={gonder}>
            <p className="mt-1 mb-5 text-sm leading-relaxed text-wait">
              Telefon numaranızı girin. Hesabınızda kayıtlı e-posta adresine
              şifre belirleme bağlantısı göndereceğiz.
            </p>

            <label className="mb-1 block text-sm font-medium text-ink-2" htmlFor="tel-unuttum">
              Telefon
            </label>
            <input
              id="tel-unuttum"
              type="tel"
              inputMode="numeric"
              autoComplete="username"
              autoFocus
              placeholder="0554 178 17 74"
              value={telefon}
              onChange={(e) => setTelefon(e.target.value)}
              className="num mb-5 w-full rounded-(--radius-mod) border border-line-2 px-3 py-2.5 text-base outline-none focus:border-navy"
            />

            <button
              type="submit"
              disabled={gonderiliyor || !telefon}
              className="w-full rounded-(--radius-mod) bg-navy px-4 py-2.5 font-medium text-white disabled:opacity-40"
            >
              {gonderiliyor ? 'Gönderiliyor…' : 'Bağlantı gönder'}
            </button>
            <button
              type="button"
              onClick={onGeri}
              className="mt-2 w-full rounded-(--radius-mod) border border-line-2 px-4 py-2.5 text-sm font-medium text-muted hover:bg-surface-2 hover:text-ink"
            >
              Vazgeç
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
